export default __webpack_public_path__ + "static/media/wheel_1.f6546c3e.svg";